import React, { useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";

const TelInput = ({
                      label,
                      type,
                      name,
                      required,
                      defaultValue,
                      onChange,
                      control,
                      maxLength,
                      readOnly,
                      disabled,
                      isControled,
                      errors,
                  }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        const currentRef = inputRef.current;
        const listener = (evt) => {
            !/(^\d*\.?\d*$)|(Backspace|Control|Meta)/.test(evt.key) &&
            evt.preventDefault();
        };

        if (
            type === "number" &&
            currentRef &&
            navigator.userAgent.indexOf("Firefox") !== -1
        ) {
            currentRef.addEventListener("keydown", listener);
        }

        return () => {
            currentRef?.removeEventListener("keydown", listener);
        };
    }, [type]);

    return (
        <Form.Group className={`mb-3 mx-2 ${disabled ? "disabled-input" : ""}`}>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                readOnly={readOnly}
                disabled={disabled}
                render={({ field }) => (
                    <>
                        <Form.Label className="fw-bold pb-1">
                            {label}
                            {required && <span className="mx-1 text-danger">*</span>}
                        </Form.Label>

                        <input
                            readOnly={readOnly}
                            type={type}
                            // minLength='11'
                            autoComplete="off"
                            className="form-control mb-2 text-center w-75 ltr"
                            ref={inputRef}
                            {...field}
                            value={
                                isControled
                                    ? field.value !== undefined
                                        ? field.value || defaultValue
                                        : defaultValue
                                    : field.value
                            }
                            onChange={(e) => {
                                const value =
                                    type === "number"
                                        ? Number(e.target.value.replace(/[^0-9]/g, ""))
                                        : e.target.value;
                                field.onChange(value);
                                if (onChange) onChange(value);
                            }}
                            onKeyPress={(e) => {
                                if (type === "tel" && !/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            maxLength={maxLength }
                        />
                    </>
                )}
            />
              {errors && (<div
                    className="text-danger">{errors[name]?.message}</div>)}
        </Form.Group>
    );
};

export default TelInput;